import { Component, OnInit, ViewChild } from '@angular/core';
import { Globals } from '../../globals';
import { ToastrService } from 'ngx-toastr';
import { CoachService, UserInfoDto } from 'app/services/coach/CoachService';
import { ClientsService } from '../../services/client/ClientsService';
import { AdminService } from '../../services/admin/AdminService';
import { CryptoJs } from '../../shared/crypto-js/crypto-js.component';
import { PurchaseAssessmentModalComponent } from '../../purchase-assessment-modal/purchase-assessment-modal.component';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

    @ViewChild('purchaseAssessment', {static: true}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    userInfo = {
        firstName: '',
        lastName: '',
        business: '',
        email: '',
        logo: '',
        currentPassword: '',
        password1: '',
        password2: '',
        ELICertified: true
    }
    onlyOne = true;
    tabIndex = 0;

    securityQuestions: any[] = [];
    questionsLoaded = false;
    securityAnswers = {
        question1: '',
        answer1: '',
        question2: '',
        answer2: '',
    }

    passwordIsValid = false;
    selfAssessments: any = [];
    assessments360: any = [];

    constructor
    (
        public _Globals: Globals,
        private _toastr: ToastrService,
        private _AdminService: AdminService,
        private _CoachService: CoachService,
        private _ClientsService: ClientsService,
        private _CryptoJs: CryptoJs
    ) {
    }

    ngOnInit() {
        this.getCoachProfile();
        $('.sidebar-wrapper li').removeClass('active');
    }

    getCoachProfile() {

        this._CoachService.getCoachProfile(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('getCoachProfile_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log(_data);
                this.userInfo.firstName = _data.FirstName;
                this.userInfo.lastName = _data.LastName;
                this.userInfo.business = _data.BusinessName;
                this.userInfo.email = _data.Email;
                this.userInfo.logo = _data.Logo;
                this.userInfo.ELICertified = _data.ELICertified;

                if (_data.ELICertified) {
                    this.getAvailableAssessmentsAuthorized();
                }

                if (this.userInfo.logo != '') {
                    const image = new Image();

                    let top = 78;
                    if (window.innerWidth < 484) {
                        top = 111;
                    }

                    image.src = 'data:image/jpeg;base64,' + this.userInfo.logo;
                    if (this.onlyOne) {
                        this.onlyOne = false;
                        $('.img-ul-container').append(image);
                    }
                    $('.img-ul-container img').css({
                        'height': '86px',
                        'margin': '6px',
                        'width': '86px'
                    });

                    $('.img-ul-container').append('<span id="removeCurrentLogo">x</span>');
                    $('.img-ul-container span').css({
                        'background-color': '#000',
                        'border-radius': '2px',
                        'color': '#FFF',
                        'cursor': 'pointer',
                        'float': 'right',
                        'height': '20px',
                        'margin': '2px',
                        'opacity': '.7',
                        'text-align': 'center',
                        'width': '20px',
                        'position': 'absolute',
                        'left': '80px',
                        'top': `${top}px`
                    });

                    document.getElementById('removeCurrentLogo').addEventListener('click', () => {
                        this.removeBase64Logo();
                    });

                }

            }
        });
    }

    getAvailableAssessmentsAuthorized() {
        this._CoachService.getAvailableAssessmentsAuthorized(this._Globals.getUserId()).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                const _data = JSON.parse(data.result.Data);
                console.log('getAvailableAssessmentsAuthorized_response', _data);
                if (_data.length != 0) {
                    this.selfAssessments = _data[_data.findIndex(x => x.AssessmentId === 1)];
                    this.assessments360 = _data[_data.findIndex(x => x.AssessmentId === 34)];
                } else {
                    this.selfAssessments = {
                        Amount: 0,
                        AssessmentId: 1,
                        Id: 3,
                        Is360: false
                    };

                    this.assessments360 = {
                        Amount: 0,
                        AssessmentId: 34,
                        Id: 3,
                        Is360: true
                    };
                }
            }
        });
    }

    /*Purchase Modal*/
    openPurchaseModal() {
        this._Globals.purchaseFromHome = true;
        this.purchaseAssessmentModal.show(this);
    }

    onResize(event: any) {
        this.getCoachProfile();
    }

    removeBase64Logo() {
        this.userInfo.logo = '';
        console.log('userInfo', this.userInfo);
        $('.img-ul-container img').remove();
        $('.img-ul-container span').remove();
    }


    saveCoach() {
        const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        const validEmail = regex.test(this.userInfo.email);
        console.log('Valid', validEmail)
        if (!validEmail) {
            this._toastr.warning('Please enter a valid email address', 'ELI');
            return;
        }


        const coachData = new UserInfoDto();
        coachData.FirstName = this.userInfo.firstName;
        coachData.LastName = this.userInfo.lastName;
        coachData.BusinessName = this.userInfo.business;
        coachData.Email = this.userInfo.email;
        coachData.Logo = this.userInfo.logo;

        console.log('coachData', coachData);

        if (this.userInfo.firstName == '' || this.userInfo.lastName == '') {
            this._toastr.warning('Please complete all fields', 'ELI');
            return;
        }

        this._CoachService.postSaveCoach(coachData).subscribe((data: any) => {
            console.log('postSaveCoach_response', data);

            if (this._Globals.validationToken(data.result.Result)) {
                if (data.result.Result == 1) {
                    this._toastr.success('Successfully updated.', 'ELI');
                    this._Globals.setFullName(this._CryptoJs.encrypt(this.userInfo.firstName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(this.userInfo.lastName, '9s6v9y$B&E!H@2iQfTjWnZq4t7w!z%C*'));
                } else {
                    this._toastr.error('We are sorry. An error happened while trying to update the data.', 'ELI');
                }
            }
        });
    }

    onUploadStateChanged(event) {
        console.log('onUploadStateChanged Event', event);
    }

    onUploadFinished(event) {
        console.log('onUploadFinished Event', event);
        this.userInfo.logo = event.src.split(',')[1];
        $('.img-ul-container img').remove();
        $('.img-ul-container span').remove();
    }

    onRemoved(event) {
        console.log('onRemoved Event', event);
        this.userInfo.logo = '';
    }

    preventSpace(value: string, event: any, tagId: string) {
        if (value == null || value == '') {
            if (event.keyCode == 32) {
                return false;
            }
        }
        if (value == ' ') {
            $(`#${tagId}`).val('');
        }
    }

    tabSelect(tabIndex: number) {
        console.log(tabIndex);
        this.tabIndex = tabIndex;
    }

    removeMessage() {
        $('#errorPasswordMessage').text('');
    }

    confirmationFail() {
        if (this.userInfo.password1 == '' && this.userInfo.password2 == '') {
            $('#errorPasswordMessage').text('');
        }

        if (this.userInfo.password1 != '' && this.userInfo.password2 != '') {
            if (this.userInfo.password1 !== this.userInfo.password2) {
                this._toastr.warning('Confirm password must be the same as the new password', 'ELI');
                $('#errorPasswordMessage').text('Confirm password does not match');
                $('.pass2').removeClass('passMatch');
                $('.pass2').addClass('passNotMatch');
            } else {
                $('#errorPasswordMessage').text('');
                $('.pass2').removeClass('passNotMatch');
                $('.pass2').addClass('passMatch');
            }
        }
    }

    updatePassword() {
        if (this.validForm() && this.passwordIsValid) {
            $('body').css('cursor', 'progress');
            this._ClientsService.postUpdatePasswordFromProfile(this._CryptoJs.encrypt(this.userInfo.currentPassword, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*'), this._CryptoJs.encrypt(this.userInfo.password1, '3s6v9y$B&E)H@McQfTjWnZq4t7w!z%C*'), this._Globals.getUserId()).subscribe((data: any) => {

                console.log('response_postUpdatePasswordFromProfile', data);
                $('body').css('cursor', 'default');

                switch (data.result.Result){
                    case 1:
                        this._Globals.userEmail = this.userInfo.email;
                        this._toastr.success('Password updated successfully.', 'ELI');
                        break;
                    case -1:
                        this._toastr.error('Current password is incorrect.', 'ELI');
                        break
                    default:
                        this._toastr.error('We are sorry. An error happened while trying to update the password.', 'ELI');
                }
            });
        } else {
            this._toastr.warning('Please enter a valid password.', 'ELI');
        }
    }

    validForm() {
        if ((this.userInfo.password1 !== this.userInfo.password2) || (this.userInfo.password1 == '' && this.userInfo.password2 == '')) {
            $('.pass2').removeClass('passMatch');
            $('.pass2').addClass('passNotMatch');
            return false;
        } else {
            $('.pass2').removeClass('passNotMatch');
            $('.pass2').addClass('passMatch');
        }
        return true;
    }

    disableSelected(selected, target) {
        console.log('Selected id', selected);

        if ($('input[name="answer1"]').val() != '' || $('input[name="answer2"]').val() != '') {
            if (target == 2) {
                this.securityAnswers.answer1 = '';
            } else {
                this.securityAnswers.answer2 = '';
            }
        }


        $(`select[name=questions${target}] option`).prop('disabled', false);

        if (selected != 0) {
            $(`select[name=questions${target}] #questions${target}_${selected}`).prop('disabled', true);
        }

    }

    passwordValid(event) {
        this.passwordIsValid = event;
    }

    getUserPersonalData() {
        $('body').css('cursor', 'wait');

        this._AdminService.getUserPersonalData(this._Globals.getUserId()).subscribe((data: any) => {
            console.log('response_getUserPersonalData', data);
            $('body').css('cursor', 'default');

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                $("input[name='first_name']").val(_data.vg6);
                $("input[name='last_name']").val(_data.hj7);
                $("input[name='user_email']").val(_data.sr3);
                $("input[name='contact_id']").val(_data.by3);

                if (_data.by3 != "0") {
                    this.ssoToShopify();
                }
                else {
                    this._toastr.warning('You are not authorized to access the requested page', "ELI");
                }
            }
        })
    }

    ssoToShopify() {

        var shopifyForm: any = document.getElementById('shopifyForm');
        shopifyForm.submit();
    }
}
